import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../utils/axiosConfig";
import { getApiUrl } from "../../utils/urlHelper.js";
import "../../styles/common/Navbar.css";
import "../../styles/dashboard/UserMarketing.css";
import { FiMenu, FiSettings, FiHelpCircle, FiShield, FiYoutube, FiInfo, FiLogOut } from "react-icons/fi";
import { FaInstagram, FaStar } from "react-icons/fa";
const Navbar = ({ isAlbum, albumTitle, onBack, rightActions }) => {
  const navigate = useNavigate();
  const [name, setName] = useState("User");
  const [selfie, setSelfie] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const dropdownRef = useRef(null);

  useEffect(() => {
    try {
      const localUser = JSON.parse(localStorage.getItem("user") || "{}");
      if (localUser.name) setName(localUser.name);
      if (localUser.selfie) setSelfie(localUser.selfie);
      if (localUser.role === "admin") setIsAdmin(true);
    } catch (e) { }

    api
      .get("/profile")
      .then((res) => {
        if (res.data?.name) setName(res.data.name);
        if (res.data?.selfie) setSelfie(res.data.selfie);
        if (res.data?.role === "admin") setIsAdmin(true);
      })
      .catch(() => { });
  }, []);

  useEffect(() => {
    if (!isDropdownOpen) return;

    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsDropdownOpen(false);
      }
    };

    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        setIsDropdownOpen(false);
        const trigger = dropdownRef.current?.querySelector("button");
        if (trigger) trigger.focus();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isDropdownOpen]);

  const homepage = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    navigate(user?.role === "admin" ? "/admin-dashboard" : "/user-dashboard");
  };

  const handleLogout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      console.error(e);
    }
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("role");
    navigate("/login");
  };

  return (
    <nav className="navbar-foto quickphoto-navbar">
      <div className="quickphoto-nav-left">
        {isAlbum ? (
          <button className="quickphoto-pill-back" onClick={onBack || homepage}>
            ‹ Fotographiya
          </button>
        ) : (
          <a
            href="/"
            onClick={(e) => {
              e.preventDefault();
              homepage();
            }}
            className="navbar-left-foto"
          >
            <img
              src="/images/logo_colored_white.png"
              alt="Fotographiya"
              className="logo-foto"
              width="1299"
              height="192"

            />
          </a>
        )}
      </div>

      <div className="quickphoto-nav-right">
        {rightActions}

        {isAlbum ? (
          <div className="hamburger-container" ref={dropdownRef}>
            <button
              className="hamburger-menu-btn"
              onClick={() => setIsDropdownOpen((prev) => !prev)}
              title="Menu"
              aria-expanded={isDropdownOpen}
              aria-controls="navbar-dropdown-menu-1"
              aria-label={isDropdownOpen ? "Close menu" : "Open menu"}
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '8px', background: 'transparent', border: 'none', cursor: 'pointer', color: '#555555' }}
            >
              <FiMenu size={24} />
            </button>

            {isDropdownOpen && (
              <ul className="dropdown-menu-foto quickphoto-dropdown-menu" id="navbar-dropdown-menu-1">
                {isAdmin && (
                  <li role="none">
                    <button
                      className="dropdown-item-foto"
                      style={{ color: "#7c3aed", fontWeight: 700 }}
                      onClick={() => {
                        setIsDropdownOpen(false);
                        navigate("/super-admin");
                      }}
                      role="menuitem"
                    >
                      👑 Super Admin Console
                    </button>
                  </li>
                )}
                <li role="none">
                  <button
                    className="dropdown-item-foto"
                    onClick={() => {
                      setIsDropdownOpen(false);
                      navigate("/profile-setting");
                    }}
                    role="menuitem"
                  >
                    <FiSettings size={16} style={{color: '#555555'}} /> Profile Settings
                  </button>
                </li>

                <li role="none">
                  <a
                    className="dropdown-item-foto"
                    href="https://www.fotographiya.com/aboutUs"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => {
                      setIsDropdownOpen(false);
                    }}
                    
                    role="menuitem"
                  >
                    <FiHelpCircle size={16} style={{color: '#555555'}} /> Help & Support
                  </a>
                </li>
                <li role="none">
                  <a
                    className="dropdown-item-foto"
                    href="https://www.fotographiya.com/privacy"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => {
                      setIsDropdownOpen(false);
                    }}
                    
                    role="menuitem"
                  >
                    <FiShield size={16} style={{color: '#555555'}} /> Privacy & Security
                  </a>
                </li>
                <li role="none">
                  <a
                    className="dropdown-item-foto"
                    href="https://www.instagram.com/fotographiya_official/"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => {
                      setIsDropdownOpen(false);
                    }}
                    role="menuitem"
                  >
                    <FaInstagram size={16} style={{color: '#e1306c'}} /> Instagram
                  </a>
                </li>
                <li role="none">
                  <a
                    className="dropdown-item-foto"
                    href="https://www.youtube.com/@Fotographiya_official"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => {
                      setIsDropdownOpen(false);
                    }}
                    role="menuitem"
                  >
                    <FiYoutube size={16} style={{color: '#ff0000'}} /> YouTube
                  </a>
                </li>
                <li role="none">
                  <a
                    className="dropdown-item-foto"
                    href="https://g.page/r/CZRiMBryiw02EAI/review"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => {
                      setIsDropdownOpen(false);
                    }}
                    role="menuitem"
                  >
                    <FaStar size={16} style={{color: '#f59e0b'}} /> Review on Google
                  </a>
                </li>
                <li role="none">
                  <a
                    className="dropdown-item-foto"
                    href="https://www.fotographiya.com/about"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => {
                      setIsDropdownOpen(false);
                    }}
                    role="menuitem"
                  >
                    <FiInfo size={16} style={{color: '#555555'}} /> About Fotographiya
                  </a>
                </li>
                <li className="dropdown-divider-line" role="separator"></li>
                <li role="none">
                  <button
                    className="dropdown-item-foto logout-item"
                    onClick={() => {
                      setIsDropdownOpen(false);
                      handleLogout();
                    }}
                    
                    role="menuitem"
                  >
                    <FiLogOut size={16} style={{color: '#ff4d4f'}} /> Logout
                  </button>
                </li>
              </ul>
            )}
          </div>
        ) : (
          <div className="hamburger-container" ref={dropdownRef}>
            <button
              className="user-profile-foto"
              onClick={() => setIsDropdownOpen((prev) => !prev)}
              aria-expanded={isDropdownOpen}
              aria-controls="navbar-dropdown-menu-2"
              aria-haspopup="menu"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                cursor: "pointer",
                padding: "4px 10px",
                borderRadius: "20px",
                background: "#f8f9fa",
                border: "1px solid #e0e0e0"
              }}
            >
              <img
                src={
                  selfie
                    ? selfie.startsWith("http")
                      ? selfie
                      : getApiUrl(selfie)
                    : `https://ui-avatars.com/api/?name=${name}&background=random`
                }
                alt={name}
                className="profile-img-foto"
                style={{ width: "32px", height: "32px", borderRadius: "50%", objectFit: "cover" }}
                onError={(e) => {
                  e.target.src = `https://ui-avatars.com/api/?name=${name}&background=random`;
                }}
              />
              <span className="dropdown-name-foto" style={{ fontWeight: 600, color: "#333333", fontSize: "14px" }}>
                {name}
              </span>
              <span className="dropdown-arrow-foto" style={{ fontSize: "10px", color: "#666666" }}>
                ▼
              </span>
            </button>

            {isDropdownOpen && (
              <ul className="dropdown-menu-foto quickphoto-dropdown-menu" id="navbar-dropdown-menu-2">
                {isAdmin && (
                  <li role="none">
                    <button
                      className="dropdown-item-foto"
                      style={{ color: "#7c3aed", fontWeight: 700 }}
                      onClick={() => {
                        setIsDropdownOpen(false);
                        navigate("/super-admin");
                      }}
                      role="menuitem"
                    >
                      👑 Super Admin Console
                    </button>
                  </li>
                )}
                <li role="none">
                  <button
                    className="dropdown-item-foto"
                    onClick={() => {
                      setIsDropdownOpen(false);
                      navigate("/profile-setting");
                    }}
                    role="menuitem"
                  >
                    <FiSettings size={16} style={{color: '#555555'}} /> Profile Settings
                  </button>
                </li>

                <li role="none">
                  <a
                    className="dropdown-item-foto"
                    href="https://www.fotographiya.com/aboutUs"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => {
                      setIsDropdownOpen(false);
                    }}
                    
                    role="menuitem"
                  >
                    <FiHelpCircle size={16} style={{color: '#555555'}} /> Help & Support
                  </a>
                </li>
                <li role="none">
                  <a
                    className="dropdown-item-foto"
                    href="https://www.fotographiya.com/privacy"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => {
                      setIsDropdownOpen(false);
                    }}
                    
                    role="menuitem"
                  >
                    <FiShield size={16} style={{color: '#555555'}} /> Privacy & Security
                  </a>
                </li>
                <li role="none">
                  <a
                    className="dropdown-item-foto"
                    href="https://www.instagram.com/fotographiya_official/"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => {
                      setIsDropdownOpen(false);
                    }}
                    role="menuitem"
                  >
                    <FaInstagram size={16} style={{color: '#e1306c'}} /> Instagram
                  </a>
                </li>
                <li role="none">
                  <a
                    className="dropdown-item-foto"
                    href="https://www.youtube.com/@Fotographiya_official"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => {
                      setIsDropdownOpen(false);
                    }}
                    role="menuitem"
                  >
                    <FiYoutube size={16} style={{color: '#ff0000'}} /> YouTube
                  </a>
                </li>
                <li role="none">
                  <a
                    className="dropdown-item-foto"
                    href="https://g.page/r/CZRiMBryiw02EAI/review"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => {
                      setIsDropdownOpen(false);
                    }}
                    role="menuitem"
                  >
                    <FaStar size={16} style={{color: '#f59e0b'}} /> Review on Google
                  </a>
                </li>
                <li role="none">
                  <a
                    className="dropdown-item-foto"
                    href="https://www.fotographiya.com/about"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => {
                      setIsDropdownOpen(false);
                    }}
                    role="menuitem"
                  >
                    <FiInfo size={16} style={{color: '#555555'}} /> About Fotographiya
                  </a>
                </li>
                <li className="dropdown-divider-line" role="separator"></li>
                <li role="none">
                  <button
                    className="dropdown-item-foto logout-item"
                    onClick={() => {
                      setIsDropdownOpen(false);
                      handleLogout();
                    }}
                    
                    role="menuitem"
                  >
                    <FiLogOut size={16} style={{color: '#ff4d4f'}} /> Logout
                  </button>
                </li>
              </ul>
            )}
          </div>
        )}
      </div>
    </nav>
  );
};


export default Navbar;

